<template>
  <div>
      
    <AppPagination :currentPage="currentPage" :totalPages="maxPage" @page-change="fetchCurrentPage" />
        
    <table class="paginated-table">
      <thead>
      <th v-for="heading in headings" :key="'heading-' + heading">{{ heading }}</th>
      </thead>
      <tbody>
      <tr v-for="(item, itemIndex) in filteredData" :key="'filtered-item-' + itemIndex"
          :class="{ 'isCancelled': item.isCancelled === '1' }">
        <td v-for="(column, columnIndex) in columns" :key="'item-column-' + columnIndex">
          <slot :name="'cell-' + column" :item="item" :column="column">
            <span v-if="hasValue(item, column)" v-html="itemValue(item, column)"></span>
          </slot>
        </td>
      </tr>
      </tbody>
    </table>
        

    <AppPagination :currentPage="currentPage" :totalPages="maxPage" @page-change="fetchCurrentPage" v-if="maxPage > 1"/>

  </div>
</template>

<script>
import AppPagination from './AppPagination.vue';

const euroFormat = Intl.NumberFormat('en-DE', {
  style: 'currency',
  currency: 'EUR'
});

export default {
  components: {
    AppPagination
  },
  props: {
    headings: Array,
    columns: Array,
    data: Array,
    maxPage: {
      default: 0,
    },
    currentPage: {
      default: 0,
    },
    isLoading: {
      default: true,
    },
  },
  computed: {
    filteredData() {
      return this.data
    },
  },
  methods: {
    hasValue(item, column) {
      return item[column] !== 'undefined'
    },
    itemValue(item, column) {
      if (column === 'locale') {
        return `<img src="https://images.ferryhopper.com/assets/flags/${item[column]}.svg" alt="flag" class="flag-icon"/>`
      }

      if ((column === 'bookingDate') || column === 'departureDate' || column === 'createdAt' || column === 'bookedDate') {
        return item[column];
      }

      if (column === 'itemGross' || column === 'itemRevenues') {
        return euroFormat.format(item[column])
      }

      if (column === 'initialBookingAmount' && item[column] !== '-') {
        return euroFormat.format(item[column])
      }

      return `<span>${item[column]}</span>`
    },
    fetchCurrentPage(page) {
      this.$store
        .dispatch('authentication/validateActiveSession')
        .then(() => this.$emit('changePage', page))
        .catch((e) => {
          this.$router.push('home')
        })
    },
  },
}
</script>



